import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, FormControl, FormHelperText, TextField } from '@mui/material'
import Consider from 'src/assets/images/Consider.svg'
import MaternityInsurancePlanCard from 'src/components/Individual/AddedServices/MaternityInsurancePlanCard'
import handView from 'src/assets/AddedServices/handView.svg'
import MotherImage from 'src/assets/AddedServices/MotherImage.svg'
import MotherNeeds from 'src/assets/AddedServices/MotherNeeds.svg'
import Loading from 'src/assets/AddedServices/Loading.gif'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { NAME_REGEX, PHONE_REGEX } from 'src/utils/constants/BuyPolicyMotor'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import { useDispatch, useSelector } from 'react-redux'
import {
  CONTACT_FORM_ERROR_MESSAGES,
  DashboardEmailsEnums,
} from 'src/utils/constants/ValueAddedServicesData'
import { useMutation } from '@apollo/client'
import { RAISE_REQUEST } from 'src/services/individualService'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import LoadingModal from 'src/components/common/LoadingModal'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers'
import {
  MATERNITY_COVERAGE,
  NOTIFICATION_SETTINGS_MSG,
} from 'src/utils/constants/Individual'

const NewBorn = () => {
  const classes = useStyles()
  const initialValues = {
    name: '',
    phone: '',
    scheduledTime: '',
  }

  const dispatch = useDispatch()

  const { loggedInUserInfo } = useSelector((state) => {
    return {
      loggedInUserInfo: state?.userInfo,
    }
  })

  const getDateTime = () => {
    if (contactForm?.values?.scheduledTime) {
      return dayjs(contactForm?.values?.scheduledTime)
    }
    return null
  }

  const contactForm = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      name: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.NAME_REQUIRED)
        .matches(NAME_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_NAME),
      phone: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.PHONE_REQUIRED)
        .matches(PHONE_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .max(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .min(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE),
      scheduledTime: Yup.date().required(
        CONTACT_FORM_ERROR_MESSAGES?.SCHEDULED_TIME
      ),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleSubmit(values, setSubmitting)
    },
    enableReinitialize: true,
  })

  const handleSubmit = (values, setSubmitting) => {
    setSubmitting(true)
    raiseRequest({
      variables: {
        emailsDetails: {
          emailType: DashboardEmailsEnums?.MATERNITY_ENQUIRY,
          name: values?.name,
          phoneNumber: values?.phone,
          email: loggedInUserInfo?.userInfo?.userData?.emailId,
          preferredTime: dayjs(values?.scheduledTime).format(
            'YYYY-MMMM-DD, h:mm A'
          ),
        },
      },
    })
  }

  const [raiseRequest, { loading }] = useMutation(RAISE_REQUEST(), {
    onCompleted: () => {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.SUCCESS,
          message: MATERNITY_COVERAGE,
        })
      )
      contactForm.resetForm({
        ...initialValues,
      })
    },
    onError: () => {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_SETTINGS_MSG?.ENCOUNTERED_ERROR_ON_REQUEST_RAISED,
        })
      )
    },
  })

  const handleFollowUpDateTimeChange = (event) => {
    contactForm.setFieldValue('scheduledTime', event?.format(), true)
  }
  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.animatedItem}>
        <div className={classes.mainContainer}>
          <div className={classes.motherContent}>
            <div className={classes.motherImageContent}>
              <div className={classes.motherImageContainer}>
                <img
                  src={MotherImage}
                  alt='motherImage'
                  className={classes.motherImage}
                />
              </div>
              <div className={classes.loadingGifContainer}>
                <img
                  src={Loading}
                  alt='loadingGif'
                  className={classes.loadingGif}
                />
              </div>
              <div className={classes.motherNeedsContainer}>
                <img
                  src={MotherNeeds}
                  alt='motherNeeds'
                  className={classes.motherNeeds}
                />
              </div>
            </div>
            <div className={classes.motherTextContent}>
              <div>
                <div className={classes.motherText}>
                  Mothers should experience pregnancywithout
                  <span className={classes.motherSubText}>
                    unnecessary worries.
                  </span>
                </div>
                <div>
                  <div className={classes.didyouknowText}>
                    <span>
                      Did you know that maternity coverage isn&apos;t available
                      right from the start in health insurance? There&apos;s
                      typically a waiting period of at least 9 months, depending
                      on the policy type.
                    </span>
                  </div>
                  <div className={classes.didyouknowText}>
                    <span>
                      That&apos;s why it&apos;s a good idea to buy health
                      insurance with maternity cover shortly after getting
                      married.
                    </span>
                  </div>
                </div>
              </div>
              <div className={classes.connectWithContent}>
                <div>
                  <div>
                    <span className={classes.connectText}>Connect with</span>
                    <br></br>
                    <span className={classes.maternityText}>
                      Trovity&apos;s Maternity Coverage Counselling
                    </span>
                  </div>
                  <div>
                    <span className={classes.newlywedsText}>
                      for Newlyweds and Married Couples.
                    </span>
                  </div>
                </div>
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className={classes.inputContainer}>
                    <div className={classes.input}>
                      <FormControl>
                        <TextField
                          id='name'
                          name='name'
                          label='Name'
                          type='text'
                          placeholder='Name*'
                          value={contactForm.values.name}
                          onChange={contactForm.handleChange}
                          onBlur={contactForm.handleBlur}
                          error={isFormControlError(contactForm, 'name')}
                          helperText={getFormControlErrorText(
                            contactForm,
                            'name'
                          )}
                          required
                          className={classes.formFieldStyles}
                          size='small'
                        />
                      </FormControl>
                    </div>
                    <div className={classes.input}>
                      <FormControl>
                        <TextField
                          id='phone'
                          name='phone'
                          label='Phone'
                          type='number'
                          placeholder='Phone*'
                          value={contactForm.values.phone}
                          onChange={(event) => {
                            event.target.value = Math.max(
                              0,
                              parseInt(event.target.value)
                            )
                              .toString()
                              .slice(0, 10)
                            contactForm.setFieldValue(
                              'phone',
                              event.target.value,
                              false
                            )
                          }}
                          onBlur={contactForm.handleBlur}
                          error={isFormControlError(contactForm, 'phone')}
                          helperText={getFormControlErrorText(
                            contactForm,
                            'phone'
                          )}
                          required
                          size='small'
                          className={classes.formFieldStyles}
                        />
                      </FormControl>
                    </div>
                    <div className={classes.input}>
                      <FormControl>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            orientation='landscape'
                            id='scheduledTime'
                            slotProps={{ textField: { size: 'small' } }}
                            label='Preferred Time *'
                            minDateTime={dayjs()}
                            views={['year', 'month', 'day', 'hours', 'minutes']}
                            onChange={handleFollowUpDateTimeChange}
                            value={getDateTime()}
                            className={classes.datePicker}
                            viewRenderers={{
                              hours: renderTimeViewClock,
                              minutes: renderTimeViewClock,
                              seconds: renderTimeViewClock,
                            }}
                          />
                        </LocalizationProvider>
                        {isFormControlError(contactForm, 'scheduledTime') ? (
                          <FormHelperText
                            className={classes.timeFormHelperText}
                          >
                            {getFormControlErrorText(
                              contactForm,
                              'scheduledTime'
                            )}
                          </FormHelperText>
                        ) : null}
                      </FormControl>
                    </div>
                    <div>
                      <Button
                        className={classes.submit}
                        onClick={() => {
                          contactForm.submitForm()
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </form>
                <div>
                  <span className={classes.referText}>
                    * You can also refer your friends and family.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.disclaimerText}>
            <span>
              Disclaimer: Coverage benefits may differ between maternity plans,
              but it&apos;s crucial to consider these aspects broadly.
            </span>
          </div>
          <hr></hr>
          <div className={classes.readPointContainer}>
            <div className={classes.readTextContent}>
              <div className={classes.readContent}>Read these points</div>
              <img
                src={handView}
                alt='handImage'
                className={classes.handImage}
              />
            </div>
            <div className={classes.notCoveredContainer}>
              <div className={classes.notCoveredHeading}>
                <span>
                  Here are the things&nbsp;
                  <span className={classes.notCoveredSubHeading}>
                    not covered
                  </span>{' '}
                  by maternity insurance plans
                </span>
              </div>
              <div className={classes.notCoveredContent}>
                <ul className={classes.notCoveredItemContent}>
                  <li className={classes.notCoveredItems}>Ectopic pregnancy</li>
                  <hr></hr>
                  <li className={classes.notCoveredItems}>
                    Costs before going to the hospital
                  </li>
                  <hr></hr>
                  <li className={classes.notCoveredItems}>
                    Costs after leaving the hospital
                  </li>
                  <hr></hr>
                  <li className={classes.notCoveredItems}>
                    Tests and doctor visits before delivery
                  </li>
                </ul>
                <ul className={classes.notCoveredItemContent}>
                  <li className={classes.notCoveredItems}>Routine check-ups</li>
                  <hr></hr>
                  <li className={classes.notCoveredItems}>Surrogacy </li>
                  <hr></hr>
                  <li className={classes.notCoveredItems}>
                    Hospital cash benefit
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className={classes.considerContent}>
            <img
              src={Consider}
              alt={'considerImg'}
              className={classes.considerDiv}
            />
          </div>
          <div>
            <div className={classes.maternityHeading}>
              <span>Few Maternity Insurance Plans in India</span>
            </div>
            <MaternityInsurancePlanCard />
          </div>
        </div>
      </div>
    </>
  )
}

export default NewBorn

const useStyles = makeStyles((theme) => ({
  considerDiv: {
    width: '100%',
    overflow: 'hidden',
  },
  image: {
    width: '90%',
    height: 'auto',
    display: 'block',
  },
  maternityHeading: {
    fontSize: '20px',
    fontFamily: 'roboto',
    fontWeight: '400',
    textAlign: 'center',
    padding: '20px',
  },
  readPointContainer: {
    display: 'flex',
    gap: '20px',
    padding: '40px 0 10px 0',
    width: '100%',
  },
  readContent: {
    fontSize: '14px',
    fontFamily: 'short stack',
    color: '#FF1405',
    fontWeight: '400',
    textAlign: 'right',
  },
  handImage: {
    width: '220px',
  },
  notCoveredContent: {
    display: 'flex',
    gap: '20px',
  },
  notCoveredHeading: {
    fontSize: '20px',
    fontFamily: 'roboto',
    fontWeight: '400',
    paddingBottom: '15px',
  },
  notCoveredItems: {
    fontSize: '14px',
    fontFamily: 'roboto',
    fontWeight: '400',
  },
  formFieldStyles: {
    '&  .MuiOutlinedInput-input': {
      fontStyle: 'italic',
      fontSize: '12px',
      width: '210px',
    },
  },
  datePicker: {
    width: '235px',
    '& .MuiOutlinedInput-root': {
      height: '2.3rem !important',
      fontStyle: 'italic !important',
    },
  },
  notCoveredSubHeading: {
    color: '#FF2315',
    textTransform: 'uppercase',
  },
  notCoveredItemContent: {
    width: '50%',
  },
  readTextContent: {
    padding: '30px 0px',
    width: '25%',
    display: 'grid',
    justifyContent: 'center',
  },
  notCoveredContainer: {
    width: '75%',
  },
  disclaimerText: {
    fontSize: '12px',
    fontFamily: 'roboto',
    fontWeight: '400',
    fontStyle: 'italic',
    paddingTop: '40px',
  },
  motherContent: {
    display: 'flex',
    flexDirection: 'row',
    '@media (max-width:1200px)': {
      flexWrap: 'wrap',
      flexDirection: 'column',
    },
  },
  connectText: {
    fontSize: '12px',
    fontFamily: 'roboto',
    fontWeight: '400',
  },
  maternityText: {
    fontSize: '14px',
    color: '#EF669B',
    fontFamily: 'roboto',
    fontWeight: '700',
    lineHeight: '25px',
  },
  newlywedsText: {
    fontSize: '14px',
    fontStyle: 'italic',
    fontWeight: '300',
  },
  referText: {
    fontSize: '11px',
    fontWeight: '400',
    fontFamily: 'roboto',
    color: '#9D9D9D',
  },
  connectWithContent: {
    textAlign: 'center',
    padding: '20px 0px',
  },
  motherText: {
    fontSize: '20px',
    fontFamily: 'roboto',
    fontWeight: '400',
    padding: '20px 0px',
  },
  motherSubText: {
    fontSize: '21px',
    fontFamily: 'roboto',
    fontWeight: '700',
  },
  didyouknowText: {
    paddingBottom: '20px',
    fontSize: '14px',
    fontFamily: 'roboto',
    fontWeight: '400',
  },
  timeContent: {
    textAlign: 'center',
    justifyContent: 'center',
  },
  submit: {
    border: '1px  solid #EF669B !important',
    borderRadius: '5px !important',
    cursor: 'pointer  !important',
    color: '#B92250 !important',
    textTransform: 'unset !important',
    margin: 'unset',
    width: '90px !important',
    height: '2.2rem !important',
    fontSize: '12px !important',
    fontWeight: '400 !important',
  },
  input: {
    paddingBottom: '10px',
  },
  inputContainer: {
    padding: '20px 116px',
    display: 'initial',
    justifyContent: 'center',
  },
  motherImageContainer: {
    zIndex: '1',
    position: 'absolute',
  },
  motherImage: {
    width: '460px',
    paddingLeft: '80px',
  },
  loadingGifContainer: {
    zIndex: '2',
    position: 'absolute',
    opacity: '0.3',
  },
  loadingGif: {
    width: '256px',
    paddingTop: '235px',
    paddingLeft: '6px',
  },
  motherNeedsContainer: {
    zIndex: '3',
    position: 'absolute',
  },
  motherNeeds: {
    width: '440px',
    paddingTop: '154px',
  },
  considerContent: {
    paddingBottom: '20px',
  },
  motherTextContent: {
    width: '50%',
    zIndex: '1',
    padding: '20px 0px',
  },
  motherImageContent: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
  },
  animatedItem: {
    animation: `$myEffect 500ms ${theme.transitions.easing.easeInOut}`,
  },
  animatedItemExiting: {
    animation: `$myEffectExit 3000ms ${theme.transitions.easing.easeInOut}`,
    opacity: 0,
    transform: 'translateY(-200%)',
  },
  '@keyframes myEffect': {
    '100%': {
      opacity: 1,
      transform: 'translateX(0%)',
    },
    '0%': {
      opacity: 0,
      transform: 'translateX(10%)',
    },
  },
  '@keyframes myEffectExit': {
    '0%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0,
    },
  },
  timeFormHelperText: {
    maxWidth: '200px',
    color: '#d32f2f !important',
    fontSize: '12px',
    marginTop: 'unset !important',
    paddingTop: '5px',
  },
}))
